import { GatewayAuthentication } from "@conformite/gateway";
import { axiosInstance } from "@src/api/utils/axiosInstance";
import { captchaAxiosInstance } from "@src/api/utils/captchaAxiosInstance";
import { userSession } from "./UserSession";

export class GatewaySessionApi {
  public static async signin(
    body: GatewayAuthentication.SigninRequestType
  ): Promise<GatewayAuthentication.SigninResponseType> {
    const response =
      await captchaAxiosInstance.post<GatewayAuthentication.SigninResponseType>(
        `${GatewayAuthentication.signinRequestUrl}`,
        body,
        {
          withCredentials: true,
        }
      );
    return response.data;
  }

  public static async logout(
    body: Record<string, never>
  ): Promise<GatewayAuthentication.RevokeResponseType> {
    const response =
      await userSession.axiosInstance.post<GatewayAuthentication.RevokeResponseType>(
        GatewayAuthentication.revokeRequestUrl,
        body,
        {
          withCredentials: true,
          params: {
            noRetry: true,
          },
        }
      );
    return response.data;
  }

  public static async refresh(
    body: Record<string, never>
  ): Promise<GatewayAuthentication.RefreshResponseType> {
    const response =
      await axiosInstance.post<GatewayAuthentication.RefreshResponseType>(
        GatewayAuthentication.refreshRequestUrl,
        body,
        {
          withCredentials: true,
        }
      );
    return response.data;
  }

  public static async getSessionStatus(): Promise<GatewayAuthentication.SessionStatusResponseType> {
    const response =
      await axiosInstance.post<GatewayAuthentication.SessionStatusResponseType>(
        GatewayAuthentication.sessionStatusRequestUrl,
        {},
        {
          withCredentials: true,
        }
      );
    return response.data;
  }
}
